@if (surHours() && surHours().length > 0) {
  <ng-container
    *ngTemplateOutlet="openHoursTemplate; context: {items: surHours(), header: OpenHourTypeLabelsEnum.SURGERY}"
  ></ng-container>
}

@if (telHours() && telHours().length > 0) {
  <ng-container
    *ngTemplateOutlet="openHoursTemplate; context: {items: telHours(), header: OpenHourTypeLabelsEnum.TELEPHONE}"
  ></ng-container>
}

@if (droHours() && droHours().length > 0) {
  <ng-container
    *ngTemplateOutlet="openHoursTemplate; context: {items: droHours(), header: OpenHourTypeLabelsEnum.DROPIN}"
  ></ng-container>
}

@if (visHours() && visHours().length > 0) {
  <ng-container
    *ngTemplateOutlet="openHoursTemplate; context: {items: visHours(), header: OpenHourTypeLabelsEnum.VISITINGHOURS}"
  ></ng-container>
}

<ng-template #openHoursTemplate let-header="header" let-items="items">
  <h2 class="text-2xl font-bold mb-5">{{ header }}</h2>

  <div class="flex flex-col justify-start items-start gap-4">
    @for (openHour of items; track openHour.id) {
      <div
        class="flex justify-between items-center gap-4 w-full">
        <div class="text-base">{{ openHour.days }}</div>
        <div class="flex flex-col gap-2">
          @if (!openHour.isCommentOnly) {
            <div class="text-base">{{ openHour.hours }}</div>
          }
          @if (openHour.comment !== null && openHour.comment !== '') {
            <div
              [ngClass]="{'text-sm' : !openHour.isCommentOnly, 'text-base' : openHour.isCommentOnly}">{{ openHour.comment }}
            </div>
          }
        </div>
      </div>
    }
  </div>
</ng-template>
